<template><div><h1>VUX V2.7.6 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] column value use number type, fix binding value is not equal to datetimepicker value #2296</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] add event:on-select-single-date</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[enhance] stop moving width one item</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[feature] add disabled class #2279</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.6 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.6-144.vue?2f55e376